import React from "react";
import PhoneInput from "react-phone-number-input";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import "react-phone-number-input/style.css";
import { Box } from "@mui/material";

export const PhoneInputFormField = ({ field, form, label, isRequired, ...props }) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

    return (
        <FormControl fullWidth error={!!errorText}>
            {label && (
                <Box sx={{ mb: 2 }}>
                    <InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name}>
                        <Typography variant="body1">
                            {label}
                            {isRequired && (
                                <Typography variant="h6" color="error" component="span">
                                    {" *"}
                                </Typography>
                            )}
                        </Typography>
                    </InputLabel>
                </Box>
            )}

            {/* Phone Input */}
            <PhoneInput
                international
                defaultCountry="IN"
                value={field.value ?? null} 
                countryCallingCodeEditable={false}
                onChange={(value) => form.setFieldValue(field.name, value ?? "")}
                {...props}
                style={{
                    border: "0.5px solid #DC143C",
                    padding: "13px 15px",
                    borderRadius: "6px",
                    "& fieldset": { border: "none" },

                }}
            />
            <Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
                {errorText}
            </Typography>
        </FormControl>
    );
};








